import { createReducer, on } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import lzstring from 'lz-string';
import { clearChartAnnotations, removeChartAnnotation, setChartAnnotation } from './chart-annotations.actions';
export const chartAnnotations = createReducer([], on(setChartAnnotation, (state, { chartAnnotation, id }) => {
    const newState = cloneDeep(state);
    newState[id] = lzstring.compressToEncodedURIComponent(chartAnnotation);
    return newState;
}), on(removeChartAnnotation, (state, { id }) => {
    const newState = cloneDeep(state);
    newState.splice(id, 1);
    return newState;
}), on(clearChartAnnotations, () => {
    return [];
}));
